import React from 'react';
import ContactsManager from './modules/logistics/components/ContactsManager';

const Icon = ({ path, className = 'w-6 h-6' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth={1.5}
    stroke="currentColor"
    className={className}
  >
    <path strokeLinecap="round" strokeLinejoin="round" d={path} />
  </svg>
);

const DatabaseStatCard = ({ label, value, helper, tone = 'slate' }) => {
  const tones = {
    slate: 'border-slate-200 bg-white text-slate-900',
    cyan: 'border-cyan-200 bg-cyan-50/80 text-slate-900',
    violet: 'border-violet-200 bg-violet-50/80 text-slate-900',
    emerald: 'border-emerald-200 bg-emerald-50/80 text-slate-900',
  };

  return (
    <div className={`rounded-3xl border px-4 py-4 shadow-sm ${tones[tone] || tones.slate}`}>
      <p className="text-[11px] font-semibold uppercase tracking-[0.22em] text-slate-500">{label}</p>
      <p className="mt-2 text-xl font-black tracking-tight">{value}</p>
      <p className="mt-1 text-xs leading-5 text-slate-500">{helper}</p>
    </div>
  );
};

export default function OperationalDatabaseView({
  companyId,
  companyName,
  showMessage,
  onBackToMenu,
}) {
  return (
    <section className="min-h-full bg-slate-100 px-4 py-6 md:px-6">
      <div className="mx-auto max-w-7xl space-y-6">
        <section className="rounded-[2rem] border border-slate-200 bg-white p-5 shadow-sm md:p-6">
          <div className="flex flex-col gap-4 lg:flex-row lg:items-start lg:justify-between">
            <div className="max-w-3xl">
              <div className="flex flex-wrap items-center gap-3">
                <button
                  type="button"
                  onClick={onBackToMenu}
                  className="inline-flex items-center gap-2 rounded-2xl border border-slate-200 bg-slate-900 px-4 py-2.5 text-sm font-bold text-white transition hover:bg-slate-800"
                >
                  <Icon path="M10.5 19.5L3 12m0 0l7.5-7.5M3 12h18" className="h-4 w-4" />
                  Volver al inicio
                </button>
                <span className="rounded-full border border-cyan-200 bg-cyan-50 px-3 py-1 text-[11px] font-bold uppercase tracking-[0.16em] text-cyan-700">
                  {companyName || 'Empresa activa'}
                </span>
              </div>
              <p className="mt-4 text-[11px] font-semibold uppercase tracking-[0.24em] text-cyan-700">Centro operativo</p>
              <h1 className="mt-2 text-3xl font-black tracking-tight text-slate-900">Base de datos</h1>
              <p className="mt-3 text-sm leading-7 text-slate-600">
                Acá organizás clientes, proveedores, transportes y otros registros reutilizables de toda la operación. La idea es que esta base quede clara, ordenada y fácil de mantener fuera del flujo de crear ruta.
              </p>
            </div>

            <div className="grid gap-3 sm:grid-cols-3 lg:w-[420px]">
              <DatabaseStatCard
                label="Clientes y proveedores"
                value="Base viva"
                helper="Centralizá nombres, direcciones y contactos sin duplicar carga."
                tone="cyan"
              />
              <DatabaseStatCard
                label="Uso operativo"
                value="Reutilizable"
                helper="Los registros sirven para rutas, salidas, compras y seguimiento."
                tone="emerald"
              />
              <DatabaseStatCard
                label="Mantenimiento"
                value="Más claro"
                helper="Agregar, editar o eliminar queda concentrado en una sola vista."
                tone="violet"
              />
            </div>
          </div>
        </section>

        <section className="rounded-[2rem] border border-slate-200 bg-white p-4 shadow-sm md:p-6">
          <ContactsManager showMessage={showMessage} companyId={companyId} />
        </section>
      </div>
    </section>
  );
}
